import React, { ReactNode } from 'react';
import { ThemeProvider as StyledComponentsThemeProvider, DefaultTheme } from 'styled-components';
import { createGlobalStyle, theme } from './theme';
import merge from 'lodash/merge';

export const GlobalStyle = createGlobalStyle`
  html {
    height: 100%;
    overflow-x: hidden;
  }

  body {
    margin: 0;
    min-height: 100%;
    padding: 0;
  }

  #__next {
    min-height: 100vh;
  }

  * {
    font-family: ${(props) => props.theme.fontFamily};
  }

  ul {
      margin: 0;
      padding: 0;
  }
`;

export type ThemeProviderProps<T> = {
  /**
   * custom theme
   */
  customTheme?: T;

  /**
   * children to be rendered within this theme.
   */
  children: ReactNode;
};

export function ThemeProvider<T>({ customTheme, children }: ThemeProviderProps<T>): JSX.Element {
  return (
    <StyledComponentsThemeProvider theme={(customTheme ? merge(theme, customTheme) : theme) as DefaultTheme}>
      <GlobalStyle />
      {/* <link href="./font/stylesheet.css" rel="stylesheet"></link> */}
      {children}
    </StyledComponentsThemeProvider>
  );
}
